import { Component, OnInit } from '@angular/core';
import { OsobaSrodstvo } from './osoba-srodstvo';
import { BaseModalContainer, ModalContainerService, ModalService, UserService } from 'yt-ng-framework';
import { ActivatedRoute } from '@angular/router';

@Component({
  selector: 'yt-osoba-srodstvo',
  templateUrl: './osoba-srodstvo.component.html'
})
export class OsobaSrodstvoComponent 
extends BaseModalContainer<OsobaSrodstvo> 
implements OnInit {

  constructor(
    protected modalContainerService: ModalContainerService<OsobaSrodstvo>,
    protected activatedRoute: ActivatedRoute,
    protected modalService: ModalService,
    protected userService: UserService

  ) {
    super(modalContainerService, activatedRoute, modalService, userService);
   }

  ngOnInit() {
  }

}
